



















































































import { GeekItem } from '@/models';
import { asyncSelectMixin } from '@/shared';
import { Actions, typedStore, Getters } from '@/store';
import { buildGeekName } from '@/utils';
import Multiselect from 'vue-multiselect';
import mixins from 'vue-typed-mixins';

export default mixins(asyncSelectMixin(Actions.geek.resetGeeks, Actions.geek.fetchGeeks)).extend({
  name: 'AllGeeksMultipleSelect',
  props: {
    onMounted: Function,
    isValueShared: Boolean,
    replaceTemplate: Boolean,
  },
  data() {
    return {
      selectedGeeks: [] as GeekItem[],
    };
  },
  components: {
    Multiselect,
  },
  async mounted() {
    if (this.isValueShared) {
      this.selectedGeeks[this.selectedGeeks.length - 1] = this.geekIdSharedFilter;
    }

    if (this.onMounted) {
      this.onMounted();
    }
  },
  computed: {
    geekIdSharedFilter(): GeekItem {
      return typedStore(this).state.geek.geekSharedFilter;
    },
    filteredGeeks(): GeekItem[] {
      return typedStore(this).getters[Getters.geek.filtered];
    },
  },
  methods: {
    emitFilters() {
      this.$emit('updateFilters', this.selectedGeeks);
    },
    clearSelected() {
      this.selectedGeeks = [] as GeekItem[];
    },
    handleSharedValue() {
      if (this.isValueShared && this.geekIdSharedFilter !== this.selectedGeeks[this.selectedGeeks.length - 1]) {
        this.$store.dispatch(Actions.geek.updateGeekIdSharedFilter, this.selectedGeeks);
      }
    },
    deleteGeek(geek: GeekItem) {
      const approverIndex = this.selectedGeeks.findIndex(a => a.id === geek.id);
      this.selectedGeeks.splice(approverIndex, 1);
    },
    buildGeekName,
  },
  watch: {
    selectedGeeks() {
      this.handleSharedValue();
      this.emitFilters();
    },
  },
});
